import { logo, logoImage } from "./HeaderLogo.module.css";
import { Badge, Box, Group, Image, useMantineColorScheme } from "@mantine/core";
import { RelativeLink } from "../../components/Link";
import { useBasePath } from "../../hooks/router";
import { WEBSITE_URL } from "../../constants/website";
import { useLocale } from "../../hooks/locale";

export function HeaderLogo() {
  const pathname = useBasePath();
  const locale = useLocale();
  const { colorScheme } = useMantineColorScheme();

  const href = `${WEBSITE_URL}${locale !== "en" ? `/${locale}` : ""}`;

  const logoElement = (
    <Group gap={8} pos="relative">
      <Image
        src={colorScheme === "dark" ? "/logo-dark.png" : "/logo-light.png"}
        alt="Mapka logo"
        height="32px"
        fit="scale-down"
        className={logoImage}
      />
      <Badge size="sm" variant="light" pos="absolute" right="-50px" top="0px">
        Beta
      </Badge>
    </Group>
  );

  return (
    <Box visibleFrom="sm">
      {pathname === "/" && (
        <a href={href} className={logo} aria-label="Mapka">
          {logoElement}
        </a>
      )}
      {pathname !== "/" && (
        <RelativeLink href={pathname} className={logo} aria-label="Mapka">
          {logoElement}
        </RelativeLink>
      )}
    </Box>
  );
}
